import { render, staticRenderFns } from "./SameOffersTaken.vue?vue&type=template&id=a16d9110"
import script from "./SameOffersTaken.vue?vue&type=script&lang=js"
export * from "./SameOffersTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports